export default __webpack_public_path__ + "static/media/KahshPortal.44359206.png";